//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SelectCouponModal from '../coupons/components/select-coupon-modal';
import util from '../../lib/util';
import {formatDate} from "@/lib/date";

export default {
  name: 'memberList',
  components: {SelectCouponModal},
  filters: {
    formatDate(time, type) {
      var date = new Date(time);
      if (type === 1) {
        return formatDate(date, 'yyyy-MM-dd');
      }
      return formatDate(date, 'yyyy-MM-dd hh:mm');
    }
  },
  data() {
    const vm = this;
    return {
      loading: false,
      searchInput: {},
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          type: 'index',
          width: 66,
          title: '序号',
          align: 'center'
        },
        {
          key: 'name',
          title: '姓名',
          align: 'center',
          render: (h, params) => {
            const row = params.row;
            const actions = [];
            actions.push(h('a', {
              on: {
                click() {
                  vm.memberInfo(row.id);
                }
              }
            }, row.name));
            return h('div', actions);
          }
        },
        {
          title: '手机号',
          key: 'phoneNumber',
          align: 'center'
        },
        {
          title: '生日',
          align: 'center',
          key: 'birthdayStr'
        },
        {
          title: '证件号',
          key: 'cardNum',
          align: 'center',
          width: 185
        },
        {
          title: '积分',
          key: 'totalPoint',
          align: 'center',
          width: 100
        },
        {
          title: '会员等级',
          key: 'memberLevelStr',
          align: 'center'
        },
        {
          title: '创建日期',
          key: 'creationTimeStr',
          width: 150,
          align: 'center'
        },
        {
          title: '是否认证',
          key: 'isAuthentication',
          align: 'center',
          render: (h, params) => {
            return h('span', params.row.isAuthentication ? '是' : '否')
          }
        },
        {
          title: '认证时间',
          key: 'isAuthentication',
          align: 'center',
          render: (h, params) => {
            let t = params.row.authenticationTime;
            return h('span', t != null ? formatDate(new Date(t), 'yyyy-MM-dd hh:mm') : '')
          }
        },
      ],
      months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      cityList: [],
      selection: [],//选中会员
      showSelectCouponModel: false,
      showGiftCouponsOrPointEditModel: false,
      saving: false,
      record: {},
      rules: {
        summary: [{required: true, message: '请输入赠送原因', trigger: 'blur'}]
      }
    };
  },
  methods: {
    pageChange(page) {
      this.$store.commit('member/setCurrentPage', page);
      this.getPage();
    },
    pageSizeChange(pagesize) {
      this.$store.commit('member/setPageSize', pagesize);
      this.getPage();
    },
    async getPage() {
      this.loading = true;
      await this.$store.dispatch({
        type: 'member/getAll',
        data: this.searchInput
      }).finally(() => {
        this.loading = false;
      });
    },
    memberInfo(id) {
      this.$router.push({
        // path: '/memberInfo/' + id
        name: 'memberInfo',
        params: {
          id: id
        }
      });
    },
    getCities() {
      this.$store.dispatch({
        type: 'city/getCityList'
      }).then(() => {
        this.cityList = this.$store.state.city.cityList;
      });
    },
    cretaeTimeChange(date) {
      this.searchInput.startTime = date[0];
      this.searchInput.endTime = date[1];
    },
    onSelectChange(selection) {
      console.log(selection);
      this.selection = selection;
    },
    showGiftCouponsOrPoint() {

    },
    onGiftCouponsOrPoint() {
      this.record = {};
      this.showGiftCouponsOrPointEditModel = true;
    },
    presentTypeChange(val) {
      if (val == 0 || val == '0') {
        this.record.couponId = 0;
        this.record.couponName = '';
      } else if (val == 1 || val == '1') {
        this.record.point = 0;
      } else {
        this.record.couponId = 0;
        this.record.point = 0;
        this.record.couponName = '';

      }
    },
    onSaveGiftCouponsOrPoint() {
      this.record.channelType = 3;
      this.record.members = this.selection;
      console.log(this.record);
      this.$refs.couponsOrPointForm.validate(async (val) => {
            if (val) {
              this.saving = true;
              abp.ajax.post('/api/services/app/Birthday/SaveMemberListCouponAndPoint', this.record).then(() => {
                this.getPage();
                this.showGiftCouponsOrPointEditModel = false;
              }).finally(() => {
                this.saving = false;
              });
            }
          }
      );
    },
    showAddACoupon() {
      this.showSelectCouponModel = true;
    },
    addCoupon(data) {
      // console.log(data);
      this.record.couponName = data.name;
      this.record.couponId = data.id;
      this.showSelectCouponModel = false;

    },
    onExport() {
      var u = '?name=';
      if (this.searchInput.name) {
        u = u + this.searchInput.name;
      } else {
        u = u + '';
      }
      if (this.searchInput.phoneNumber) {
        u = u + '&phoneNumber=' + this.searchInput.phoneNumber;
      }

      if (this.searchInput.memberLevel != undefined) {
        u = u + '&memberLevel=' + this.searchInput.memberLevel;
      }
      if (this.searchInput.cityId != undefined) {
        u = u + '&cityId=' + this.searchInput.cityId;
      }
      if (this.searchInput.month != undefined) {
        u = u + '&month=' + this.searchInput.month;
      }

      if (this.searchInput.startTime != undefined) {
        u = u + '&startTime=' + this.searchInput.startTime;
      }
      if (this.searchInput.endTime != undefined) {
        u = u + '&endTime=' + this.searchInput.endTime;
      }

      let url = util.ApiUrl + 'ServiceReport/MemberListExport' + u;
      window.open(url, '_blank');
    },
    hasPermission(permission) {
      return abp.auth.isGranted(permission);
    },

    authTimeChange(date) {
      console.log(date)
      if (date && !date.includes('')) {
        this.searchInput.authTimes = date;
      } else {
        this.searchInput.authTimes = []
      }

    },

  },
  computed: {
    list() {
      return this.$store.state.member.list;
    },
    currentPage() {
      return this.$store.state.member.currentPage;
    },
    pageSize() {
      return this.$store.state.member.pageSize;
    },
    totalCount() {
      return this.$store.state.member.totalCount;
    }
  },
  created() {
    this.getPage();
    this.getCities();
  }
};
